import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormatPipe } from '../../pipes/format.pipe';
import { Snackbar } from '../../services/snackbar/snackbar.service';
import { ButtonComponent } from '../core/buttons/button.component';
import { ToolbarButtonComponent } from '../core/buttons/toolbar-button.component';
import { IconComponent } from '../core/labels/icon.component';
import { LabelComponent } from '../core/labels/label.component';
import { LinkLabelComponent } from '../core/labels/link-label.component';
import { ProgressbarComponent } from '../core/labels/progressbar.component';
import { TagComponent } from '../core/labels/tag.component';
import { ToastComponent } from '../core/labels/toast.component';
import { EmptyStateComponent } from '../core/panels/empty-state.component';

@Component({
  selector: 'app-color-design',
  imports: [
    CommonModule,
    RouterModule,
    IconComponent,
    EmptyStateComponent,
    ButtonComponent,
    ToastComponent,
    LabelComponent,
    FormatPipe,
    TagComponent,
    ToolbarButtonComponent,
    ProgressbarComponent,
    LinkLabelComponent,
  ],
  providers: [Snackbar],
  template: `
    <div class="tw-flex">
      <div class="tw-basis-1/2">
        <div class="tw-flex tw-flex-col">
          @for (color of colors; track color) {
            <div class="tw-flex tw-gap-2">
              <div
                class="tw-p-8"
                [style.background-color]="'var(' + color + ')'"
              ></div>
              <div>{{ color }}</div>
            </div>
          }
        </div>
      </div>
      <div class="tw-basis-1/2">
        <div class="tw-flex tw-flex-col tw-gap-2">
          <app-label label="hello">world</app-label>
          <div><h1>This is an H1 header</h1></div>
          <div><h2>This is an H2 header</h2></div>
          <div><h3>This is an H3 header</h3></div>
          <div><h4>This is an H4 header</h4></div>

          <div>
            <div>
              This is a
              <app-link-label [routerLink]="">hyperlink</app-link-label>
            </div>
            <div>
              This is a disabled
              <app-link-label [disabled]="true" [routerLink]=""
                >hyperlink</app-link-label
              >
            </div>
            <p>
              This is body text. Lorem ipsum odor amet, consectetuer adipiscing
              elit. Nisl suscipit dignissim senectus etiam tincidunt; sed
              hendrerit pellentesque id. Conubia porttitor ac nibh euismod velit
              quis himenaeos nisi. Varius commodo sit commodo lectus rutrum
              libero. Ultricies massa feugiat proin orci magna augue ad natoque.
              Elementum nostra mollis maximus sollicitudin eleifend finibus.
              Phasellus mollis commodo odio; faucibus lobortis interdum. Cubilia
              interdum curae nullam eros sapien lobortis blandit facilisis. Sem
              tellus orci tristique sit leo erat curabitur. Nibh quisque aenean
              ligula elit orci montes tellus. Sem dis curabitur elit quisque
              potenti nascetur mollis tempor. Non ultricies ac auctor vulputate
              consequat nullam parturient placerat. Id fames erat libero lectus
              odio scelerisque fringilla. Eget feugiat cursus pellentesque
              suspendisse arcu. Convallis cubilia pellentesque enim pulvinar a
              nulla quam primis. Ultrices morbi consequat luctus himenaeos
              luctus urna ultrices purus.
            </p>
            <div class="tw-pt-4">
              <div><b>app-icon</b> component</div>
              <app-icon name="fa-light fa-user"></app-icon>
              <app-icon name="fa-light fa-user" size="2rem"></app-icon>
              <app-icon
                name="fa-user fa-light"
                size="48px"
                color="var(--sed-status-red-color)"
              ></app-icon>

              <span class="fa-layers fa-fw" style="font-size: 48px">
                <i
                  class="fa-light fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                  data-fa-transform="-rotate-90 -grow-4"
                ></i>
                <i
                  class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-dynamic-black-color)]"
                  data-fa-transform="shrink-7 down-4 right-4"
                ></i>
              </span>

              <span class="fa-layers fa-fw" style="font-size: 48px">
                <i
                  class="fa-light fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                  data-fa-transform="-rotate-90 -grow-4"
                ></i>
                <i
                  class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-status-red-color)]"
                  data-fa-transform="shrink-7 down-4 right-4"
                ></i>
              </span>

              <span class="fa-layers fa-fw" style="font-size: 48px">
                <i
                  class="fa-light fa-wrench-simple tw-text-[var(--sed-grey-100-color)]"
                  data-fa-transform="-rotate-25 -grow-4"
                ></i>
                <i
                  class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-purple-100-color)] tw-round-full"
                  data-fa-transform="shrink-9 down-5 right-3"
                ></i>
              </span>

              <span class="fa-layers fa-fw" style="font-size: 48px">
                <i
                  class="fa-light fa-wrench-simple tw-text-[var(--sed-grey-100-color)]"
                  data-fa-transform="rotate-45 -grow-4"
                ></i>
                <i
                  class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-purple-100-color)] tw-round-full"
                  data-fa-transform="shrink-9 down-5 right-3"
                ></i>
              </span>

              <div class="tw-flex tw-flex-wrap tw-gap-4 tw-max-w-[380px]">
                <div
                  class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
                >
                  <div
                    class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                  >
                    <span class="fa-layers fa-fw">
                      <i
                        class="fa-regular fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="-rotate-45 grow-2"
                      ></i>
                      <i
                        class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-dynamic-black-color)] "
                        data-fa-transform="shrink-4 down-4 right-4"
                      ></i>
                    </span>
                  </div>
                  <span class="tw-font-bold">Test alert</span>
                </div>

                <div
                  class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
                >
                  <div
                    class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                  >
                    <span class="fa-layers fa-fw">
                      <i
                        class="fa-regular fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="-rotate-45 grow-2 left-1"
                      ></i>
                      <i
                        class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-dynamic-black-color)] "
                        data-fa-transform="shrink-4 down-4 right-5"
                      ></i>
                    </span>
                  </div>
                  <span class="tw-font-bold">Test alert</span>
                </div>

                <div
                  class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
                >
                  <div
                    class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                  >
                    <span class="fa-layers fa-fw">
                      <!-- <i
                        class="fa-regular fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="rotate-45 grow-2 left-1 up-2"
                      ></i> -->
                      <i
                        class="fa-regular fa-gavel tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="-rotate-45 grow-2 left-1 up-2"
                      ></i>
                      <i
                        class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-dynamic-black-color)] "
                        data-fa-transform="shrink-4 down-4 right-5"
                      ></i>
                    </span>
                  </div>
                  <span class="tw-font-bold">Test alert</span>
                </div>

                <div
                  class="tw-rounded-full tw-bg-[var(--sed-open-grey-color)] tw-flex tw-items-center tw-pr-4 tw-border"
                >
                  <div
                    class="tw-rounded-full tw-size-7 tw-m-2 tw-bg-[var(--sed-purple-40-color)] tw-flex tw-items-center tw-justify-center"
                  >
                    <span class="fa-layers fa-fw">
                      <!-- <i
                        class="fa-regular fa-wrench-simple tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="rotate-45 grow-2 left-1 up-2"
                      ></i> -->
                      <i
                        class="fa-solid fa-gavel tw-text-[var(--sed-black-60-color)]"
                        data-fa-transform="-rotate-45 grow-2 left-1 up-2"
                      ></i>
                      <i
                        class="fa-solid fa-pause fa-inverse tw-text-[var(--sed-dynamic-black-color)] "
                        data-fa-transform="shrink-4 down-4 right-5"
                      ></i>
                    </span>
                  </div>
                  <span class="tw-font-bold">Test alert</span>
                </div>
              </div>
            </div>
            <div class="tw-pt-4">
              <div><b>app-empty-state</b> component</div>
              <app-empty-state
                icon="fa-list"
                label="Empty watch list"
                message="Watch list items will appear here"
              />

              <app-empty-state
                icon="fa-light fa-file-arrow-down"
                label="Loading documents"
                message="Retrieving from document repository"
              >
                <div class="tw-py-4">
                  <app-progressbar />
                </div>
              </app-empty-state>

              <app-empty-state
                icon="fa-light fa-stars"
                label="Loading summary"
                message="Retrieving summary from Omni AI"
              >
                <div class="tw-py-4">
                  <app-progressbar />
                </div>
              </app-empty-state>
            </div>
            <div class="tw-pt-4">
              <div><b>app-tag</b> component</div>
              <app-tag label="Green" type="Green" />
              <app-tag label="Grey" type="Grey" />
              <app-tag label="Success" type="Success" />
              <app-tag label="Info" type="Info" />
              <app-tag label="Error" type="Error" />
            </div>
            <div>app-toolbar-button component</div>
            <div class="tw-flex tw-flex-wrap ">
              <app-toolbar-button
                icon="fa-light fa-file-export"
                ariaLabel="FileExport"
              />
              <app-toolbar-button icon="fa-light fa-save" ariaLabel="Save" />
              <app-toolbar-button
                icon="fa-light fa-filter"
                ariaLabel="Filter"
              />
              <app-toolbar-button
                icon="fa-light fa-gear"
                ariaLabel="Settings"
              />
              <app-toolbar-button icon="fa-light fa-trash" ariaLabel="Trash" />
              <app-toolbar-button label="Export" ariaLabel="Export" />
            </div>

            <div>app-button component</div>
            <div class="tw-flex tw-flex-wrap tw-gap-3">
              <app-button label="Primary" [badgeLabel]="122" />
              <app-button icon="fa-search fa-light" label="Primary Icon" />
              <app-button [disabled]="true" label="Primary Disabled" />
              <app-button [loading]="true" label="Primary Loading" />
              <app-button emphasis="Low" label="Secondary" />
              <app-button
                emphasis="Low"
                icon="fa-home fa-light"
                label="Secondary Icon"
              />
              <app-button
                emphasis="Low"
                [disabled]="true"
                label="Secondary Disabled"
              />
              <app-button
                [loading]="true"
                emphasis="Low"
                label="Secondary Loading"
              />
            </div>
            <div class="tw-pt-4">
              <div><b>app-toast</b> component</div>
              <app-toast>This is information toast</app-toast>
              <app-toast type="Success">This is success toast</app-toast>
              <app-toast type="Error">This is error toast</app-toast>

              <app-button
                (click)="
                  snackbar.show('This is information snackbar');
                  snackbar.show('This is success snackbar', 'Success');
                  snackbar.show('This is error snackbar', 'Error')
                "
                label="Show snackbars"
              />
            </div>
            <div class="tw-pt-4">
              <div><b>format pipe</b></div>
              <div>{{ true | format: 'b' }}</div>
              <div>{{ 1234.56 | format: 'c' }}</div>
              <div>{{ 1234.56 | format: 'n' }}</div>
              <div>{{ 1234.0 | format: 'n' }}</div>
              <div>{{ '111223333' | format: 's' }}</div>
              <div>{{ '*****3333' | format: 's' }}</div>
              <div>{{ '1112223333' | format: 'p' }}</div>
              <div>{{ '2011-10-05T14:48:00.000Z' | format: 'd' }}</div>
              <div>{{ '2011-10-05T14:48:00.000Z' | format: 't' }}</div>
              <div>{{ '2011-10-05T14:48:00.000Z' | format: 'dt' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class ColorDesignComponent {
  protected snackbar = inject(Snackbar);

  colors = [
    '--sed-engaged-black-color',
    '--sed-dynamic-black-color',
    '--sed-sedgwick-green-color',
    '--sed-warm-white-color',
    '--sed-open-grey-color',
    '--sed-black-80-color',
    '--sed-black-60-color',
    '--sed-grey-100-color',
    '--sed-grey-60-color',
    '--sed-grey-40-color',
    '--sed-status-green-color',
    '--sed-status-yellow-color',
    '--sed-status-blue-color',
    '--sed-status-red-color',
    '--sed-data-purple-color',
    '--sed-data-teal-color',
    '--sed-data-blue-color',
    '--sed-data-pink-color',
    '--sed-purple-100-color',
    '--sed-purple-80-color',
    '--sed-purple-60-color',
    '--sed-purple-40-color',
    '--sed-data-point-01-color',
    '--sed-data-point-01-label-color',
    '--sed-data-point-02-color',
    '--sed-data-point-02-label-color',
    '--sed-data-point-03-color',
    '--sed-data-point-03-label-color',
    '--sed-data-point-04-color',
    '--sed-data-point-04-label-color',
    '--sed-data-point-05-color',
    '--sed-data-point-05-label-color',
    '--sed-data-point-06-color',
    '--sed-data-point-06-label-color',
    '--sed-data-point-07-color',
    '--sed-data-point-07-label-color',
  ];
}
